export type Dict = Record<string, string>;

// `components.live_sheet` plus `game_terms` as `terms`, exactly as show.html.erb sends them.
export type Labels = {
	parts: Dict;
	stats: Dict;
	status: Dict;
	alignments: Dict;
	header: Dict;
	boxes: Dict;
	// A retainer's "Tornar Aventureiro" box: title, description, button and the confirmation.
	become_adventurer: Dict;
	sum: Dict;
	// What a glossary term opens: its title where `terms` has none, and its description where the book or the old sheet has one.
	glossary: Record<string, { title?: string; text?: string }>;
	attacks: Dict;
	// What the rules rule out together, by the code `derived.equip_conflicts` carries.
	equipment_conflicts: Dict;
	abilities: Dict;
	spells: Dict;
	// The spell picker: Repouso's tomorrow's spells, "Preparar magias" and the grimório's checklist.
	spells_picker: Dict;
	inventory: Dict;
	// An item's menu and form.
	item: Dict;
	details: Dict;
	// The portrait picker's words, shared by the sheet and the Oficina.
	portrait: Dict;
	edit: Dict;
	panel: Dict;
	xp: Dict;
	level_up: Dict;
	catalog: Dict;
	roll: Dict;
	rest: Dict;
	agonize: Dict;
	descriptions: Dict;
	attribute_names: Dict;
	attribute_descriptions: Dict;
	// A Ladrão's talents by key: the title and the description as HTML.
	rogue_talents: Record<string, { title: string; html: string }>;
	dice_bar: { adjustment: Dict };
	dice_roller: Dict;
	dice_failed: Dict;
	concepts: Dict;
	// The item form's field names and damage types, from the model's own translations.
	item_fields: Dict;
	damage_types: Dict;
	terms: Record<string, { abbr: string; full: string }>;
	// The Centro de Ajuda articles the new Level Up and spell preparation link to: `link` and the hrefs `level_up`, `pending`, `spells`.
	help?: Dict;
};

export function interpolate(template: string, params: Record<string, string | number> = {}): string {
	return template.replace(/%\{(\w+)\}/g, (_, key: string) => String(params[key] ?? ""));
}
